export enum PlanKey {
  BASIC = 'basic',
  PRO = 'pro',
  CUSTOM = 'custom',
}

export const PLAN_NAMES: Record<string, string> = {
  [PlanKey.BASIC]: 'Basic Plan',
  [PlanKey.PRO]: 'Pro Plan',
  [PlanKey.CUSTOM]: 'Custom Plan',
};

export interface CreateCheckoutSessionRequestDto {
  plan: 'basic' | 'pro';
  metaEventId?: string;
  fbp?: string;
  fbc?: string;
  metaSourceUrl?: string;
}

export interface CreateCheckoutSessionResponseDto {
  url: string;
}

export interface ConfirmCheckoutSessionRequestDto {
  sessionId: string;
}

export interface ConfirmCheckoutSessionResponseDto {
  confirmed: boolean;
  plan: 'basic' | 'pro' | 'custom';
}

export interface PortalSessionResponseDto {
  url: string;
}

export interface CancelTrialResponseDto {
  success: boolean;
}
